import React, { FC, MouseEvent } from 'react'

import styled from 'styled-components'

import { Icon } from 'src/components/atoms'
import { Triangle } from 'src/components/atoms/others/Triangle'

import { CommonContentPageIcons } from 'src/constants'

const Container = styled.div`
  box-shadow: 0 5px 20px 0 rgba(122, 137, 160, 0.1);
  border-radius: 4px;
  transform: translateY(-2px);
`

type Props = {
  selectedIconId: number
  selectIcon: (iconId: number) => void
  onClickClose: () => void
  className?: string
}

export const CommonContentsIconSelector: FC<Props> = ({
  selectedIconId,
  selectIcon,
  onClickClose,
  className,
}) => {
  const handleOnClose = (event: MouseEvent) => {
    event.stopPropagation()
    onClickClose()
  }

  const handleSelectIcon = (event: MouseEvent, iconId: number) => {
    event.stopPropagation()
    selectIcon(iconId)
  }

  return (
    <div className={className}>
      <Triangle className="tw-bg-surface-primary tw-w-[24px] tw-ml-[calc(var(--r7)-4px)]" />
      <Container className="tw-border-border-secondary tw-border-b tw-bg-surface-primary tw-p-s-1 tw-w-[480px]">
        <div
          role="presentation"
          onClick={handleOnClose}
          className="tw-w-fit tw-ml-auto tw-cursor-pointer"
        >
          <Icon path="close/soft/line" className="tw-text-standardText-secondary" size="--r1" />
        </div>
        <div className="tw-flex tw-flex-wrap  tw-gap-s-2 tw-mt-s-1 tw-px-s-1 tw-pb-s1">
          {CommonContentPageIcons.map(icon => (
            <div
              key={icon.id}
              className={`tw-w-[36px] tw-aspect-square tw-rounded-full tw-centering ${
                icon.id === selectedIconId
                  ? 'tw-bg-correctGreen-default'
                  : 'tw-bg-surface-primary hover:tw-bg-surface-secondary'
              }`}
            >
              <Icon
                path={icon.iconPath}
                size="--r1"
                onClick={event => handleSelectIcon(event, icon.id)}
                className={`tw-cursor-pointer ${
                  icon.id === selectedIconId
                    ? 'tw-text-inlineText-primary'
                    : 'tw-text-standardText-secondary'
                }`}
              />
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
